/* eslint-disable class-methods-use-this */

// Import libraries
import LazyLoading from "./lib/lazy-loading";

// Import components
import Cta from "./template-parts/components/cta";
import Filters from "./template-parts/components/filters";
import Newsletter from "./template-parts/components/newsletter";
import Pagination from "./template-parts/components/pagination";
import SearchForm from "./template-parts/components/search-form";

// Import popups
import NewsletterForm from "./template-parts/popups/newsletter-form";

// Import sections
import BeforeAfter from "./template-parts/sections/before-after";
import Footer from "./template-parts/sections/footer";
import Clients from "./template-parts/sections/clients";
import FeaturedContent from "./template-parts/sections/featured-content";
import ContactForm from "./template-parts/sections/contact-form";
import Gallery from "./template-parts/sections/gallery";
import Hero from "./template-parts/sections/hero";
import Map from "./template-parts/sections/map";
import Numbers from "./template-parts/sections/numbers";
import Slider from "./template-parts/sections/slider";
import SliderGallery from "./template-parts/sections/slider-gallery";
import TextVerticalSlider from "./template-parts/sections/text-vertical-slider";
import Timeline from "./template-parts/sections/timeline";

// Import templates
import Projects from "./templates/projects";

export default class ModulesLoader {
  constructor(el = document) {
    this.el = el;
  }

  loadModules() {
    // Load libraries
    window.lazyLoading = new LazyLoading();

    // Load components
    window.cta = new Cta();
    window.filters = new Filters();
    window.newsletter = new Newsletter();
    window.pagination = new Pagination();
    window.searchForm = new SearchForm();

    // Load popups
    window.newsletterForm = new NewsletterForm();

    // Load sections
    window.beforeAfter = new BeforeAfter();
    window.clients = new Clients();
    window.contactForm = new ContactForm();
    window.footer = Footer();
    window.featuredContent = FeaturedContent();
    window.gallery = new Gallery();
    window.hero = Hero();
    window.numbers = new Numbers();
    window.map = new Map();
    window.slider = new Slider();
    window.sliderGallert = new SliderGallery();
    window.textVerticalSlider = new TextVerticalSlider();
    window.timeline = new Timeline();

    // Load templates
    window.projects = new Projects();
  }
}
